module.exports = __webpack_public_path__ + "img/tema-3-25.7852b96b.png";